import {
  FindClipRequest,
  FindClipSuggestedClip,
  FindClipSuggestedEdit,
} from "./clipping-studio-find-clip";

export abstract class IClippingStudioFindClipRepository {
  abstract generateClips(
    req: FindClipRequest,
  ): Promise<FindClipSuggestedClip[]>;
  abstract generateFullEdit(
    req: FindClipRequest,
  ): Promise<FindClipSuggestedEdit>;
  /** Build suggested edit summary from clips (so count/duration match displayed clips). */
  abstract buildSuggestedEditFromClips(
    clips: FindClipSuggestedClip[],
  ): FindClipSuggestedEdit;
  /** Get recent find-clip prompts for the project. When projectId <= 0, returns []. */
  abstract getRecentPrompts(projectId: number): Promise<string[]>;
  /** Save a prompt for the project (appends to recent list on backend). When projectId <= 0, no-op. */
  abstract savePrompt(projectId: number, prompt: string): Promise<void>;
}
